export const getAvatarUrl = (avatar) => {
  const baseUrl = process.env.VUE_APP_API_BASE_URL;
  return `${baseUrl}/storage/${avatar}`;
};

export const formatDate = (date) => {
  return new Date(date).toLocaleString("vi-VN");
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return "0đ";
  }
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(value);
};

export const parseCurrency = (value) => {
  return Number(value.replace(/\D/g, "")) || 0;
};
